import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { type IAlertLinkAction, type IAlertNavLinkAction } from 'shared/ui/Alert/types'
import { LINK_COMPLIANCE_LEARN_MORE_LINK } from 'shared/constants/links'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const AlertMaxSegments = observer(() => {
  const { conversationStore, usersStore, tenDlcLimitsStore } = useEntitiesContext()
  const user = usersStore.user

  const isAircall = !!conversationStore?.conversationInboxNumber?.is_aircall
  const isTollFree = conversationStore?.conversationInboxNumber?.isTollFree

  if (isTollFree || tenDlcLimitsStore.isPlanStandard || !tenDlcLimitsStore.isOutOfSegments)
    return null

  const isRoleAdmin = !!user?.isAdminOrOwnerRole
  const isActionSettings = isRoleAdmin && !isAircall

  const title = 'You have exceeded the limits of your current 10DLC package.'
  const description = isRoleAdmin
    ? 'Upgrade to avoid non-compliance fees and message filtering'
    : 'To avoid being blocked and paying carrier penalty fees, alert your admin'

  const actions: Array<IAlertLinkAction | IAlertNavLinkAction> = []

  if (isActionSettings) {
    actions.push({
      variant: 'navLink',
      type: 'primary',
      text: 'Register here',
      link: '/settings/organization/compliance',
      appType: 'vue',
    })
  }

  actions.push({
    variant: 'link',
    type: 'primary',
    text: 'Learn more',
    link: LINK_COMPLIANCE_LEARN_MORE_LINK,
  })

  return <Alert item={{ title, desc: description, type: 'error' }} actions={actions} />
})
